import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteUnitTrigger = async (triggerId: number): Promise<boolean> =>
  axios.delete(`/my-monitoring/sites/RemoveTrigger?triggerId=${triggerId}`).then((res) => res?.data?.result)

type Props = {
  triggerId: number
}

export const useMyMonitoringDeleteUnitTrigger = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteMyMonitoringUnitTrigger'],
    mutationFn: ({ triggerId }: Props) => deleteUnitTrigger(triggerId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted trigger.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to delete trigger, please try again.')
      }
    },
    throwOnError: false
  })
